export const BNPHospitalitySlug = 'bnphospitality';
